import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "babel-runtime/helpers/possibleConstructorReturn";
import _inherits from "babel-runtime/helpers/inherits";
import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";

import { actionCreators } from "./srereducer";

import { selectors } from "./srereducer";

import styled from "@emotion/styled";

import SREIcon from "./SREIcon";

var SREPromptDiv = styled.div({
  display: "inline-block"
});

export var SREPrompt = function (_PureComponent) {
  _inherits(SREPrompt, _PureComponent);

  function SREPrompt() {
    var _temp, _this, _ret;

    _classCallCheck(this, SREPrompt);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.render = function () {
      return React.createElement(
        SREPromptDiv,
        null,
        _this.props.isSREListeningToPrompt || React.createElement(SREIcon, { widthheight: _this.props.height, ico: "mic", onClick: _this.props.onClick }),
        _this.props.isSREListeningToPrompt && React.createElement(SREIcon, { widthheight: _this.props.height, ico: "micActive", onClick: _this.props.onClick })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return SREPrompt;
}(PureComponent);

SREPrompt.defaultProps = {
  height: 40
};

SREPrompt.propTypes = {
  score: PropTypes.number,
  isSREListening: PropTypes.bool,
  isSREListeningToPrompt: PropTypes.bool,
  height: PropTypes.number
};

var mapStateToProps = function mapStateToProps(state, ownprops) {
  return {
    isSREListening: selectors.isSREListening(state),
    isSREListeningToPrompt: selectors.isSREListeningToPrompt(state, ownprops.promptId)
  };
};

var SREPromptContainer = connect(mapStateToProps, actionCreators)(SREPrompt);

export default SREPromptContainer;